// extracted by mini-css-extract-plugin
export default {"nft-card-wrapper":"NftCardWrapper_nft-card-wrapper__SGK-R"};